import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Suppress ALL console output in production (except staging/preview)
// Live domains: app.userevstar.com, admin.userevstar.com, etc.
// Staging: staging.userevstar.com (logs enabled for debugging)
// Preview: *.vercel.app (logs enabled for debugging)
if (process.env.NODE_ENV === 'production' &&
    !window.location.hostname.includes('staging') &&
    !window.location.hostname.includes('vercel.app') &&
    !window.location.hostname.includes('localhost')) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop; // Also suppress errors in production for clean console
  console.trace = noop;
  console.table = noop;
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<React.StrictMode><App /></React.StrictMode>);
